import { useEffect } from "react";
import { Grid, Icon, Typography } from "@mui/material";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import SearchCard from "components/SearchCard";
import { useForm } from "react-hook-form";
import { useSearch } from "context/SearchContext";
import { Link } from "react-router-dom";

const SearchCategory = ({ dataCategory, setDataCategory }) => {
  const { searchCategory, response, setResponse } = useSearch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm({});
  const search_category = watch("search_category");

  const listCategory = (data) => (
    <>
      <Grid item xs={10}>
        <Typography variant="h8" component="h4">
          {`Categoria: ${data.name}`}
        </Typography>
      </Grid>
    </>
  );

  useEffect(() => {
    if (search_category?.length >= 3) {
      searchCategory(search_category);
    }
  }, [search_category]);

  return (
    <Grid item xs={6}>
      <SearchCard
        title={"Categoria"}
        data={dataCategory}
        setData={setDataCategory}
        list={listCategory}
      >
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          Buscar Categorias:
        </Typography>
        <MDInput
          {...register("search_category")}
          placeholder={"Pesquise a partir de 3 letras"}
          fullWidth
        />
        {Object.values(response).map((category, index) => (
          <Link key={index}>
            <MDBox sx={{ p: 2, display: "flex", alignItems: "center" }}>
              <Icon fontSize="small" color="inherit">
                auto_awesome_motion
              </Icon>
              <Typography
                onClick={() => {
                  setDataCategory(category);
                  setResponse([]);
                }}
                key={index}
                variant="h6"
                component="h2"
              >
                {category.name}
              </Typography>
            </MDBox>
          </Link>
        ))}
      </SearchCard>
    </Grid>
  );
};

SearchCategory.propTypes = {
  dataCategory: PropTypes.object,
  setDataCategory: PropTypes.object,
};

export default SearchCategory;
